export const formatDuration = (durationMs) => {
  const ms = Number(durationMs);
  if (!Number.isFinite(ms) || ms < 0) return "";

  const totalSec = Math.floor(ms / 1000);
  const pad = (n) => String(n).padStart(2, "0");

  return [
    pad(Math.floor(totalSec / 3600)),
    pad(Math.floor((totalSec % 3600) / 60)),
    pad(totalSec % 60),
  ].join(":");
};
